// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"72ac40dd","732":"8e550ba0","977":"22e206ab"}[chunkId] + ".chunk.js";
};